import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TableClientesDataSource, TableClientesItem } from './table-clientes-datasource';
import { CrearClienteComponent } from '../../../clientes/crear-cliente/crear-cliente.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-table-clientes',
  templateUrl: './table-clientes.component.html',
  styleUrls: ['./table-clientes.component.scss']
})
export class TableClientesComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TableClientesItem>;
  dataSource: TableClientesDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['razonSocial', 'correo', 'telefono', 'estado', 'acciones'];

  constructor(public dialog: MatDialog){

  }

  ngOnInit() {
    this.dataSource = new TableClientesDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    const dialogRef = this.dialog.open(CrearClienteComponent, {
      width: '500px',
      height: '500px'
    });

  }
  
}
